import { render } from "./DocumentCenter.vue?vue&type=template&id=18401c9a&scoped=true"
import script from "./DocumentCenter.vue?vue&type=script&lang=js"
export * from "./DocumentCenter.vue?vue&type=script&lang=js"

import "./DocumentCenter.vue?vue&type=style&index=0&id=18401c9a&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18401c9a"]])

export default __exports__